
riot.tag2('parameters-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Параметры</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-4 left-block">\n          <catalog-tree object="FeatureGroup" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" descendants="true"></catalog-tree>\n        </div>\n        <div class="col-md-8 cont-block">\n          <catalog object="Feature" cols="{parent.cols}" search="true" store="parameters-list-select-modal" add="{parent.add}" remove="true" handlers="{parent.handlers}" reload="true" filters="{categoryFilters}" disable-limit="true" disable-col-select="true" dblclick="{parent.opts.submit.bind(this)}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="type">{handlers.featureName(row.type)}</datatable-cell>\n            </yield>\n          </catalog>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '.left-block { margin-top: 45px; overflow: auto; max-height: 600px; } .cont-block { margin-top: 5px; }', '', function(opts) {
'use strict';

var self = this;

var getFeaturesTypes = function getFeaturesTypes() {
    API.request({
        object: 'FeatureType',
        method: 'Fetch',
        data: {},
        success: function success(response) {
            self.featuresTypes = response.items;
            self.update();
        }
    });
};

var featureName = function featureName(type) {
    for (var i = 0; i < self.featuresTypes.length; i++) {
        if (self.featuresTypes[i].code === type) return self.featuresTypes[i].name;
    }
};

self.add = function () {
    modals.create('parameter-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var params = { name: _this.name.value };

            API.request({
                object: 'Feature',
                method: 'Save',
                data: params,
                success: function success(response) {
                    _this.modalHide();
                    if (response.id) riot.route('products/parameters/' + response.id);
                }
            });
        }
    });
};

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип' }];

self.handlers = {
    featureName: featureName
};
getFeaturesTypes();
self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.categoryFilters = false;
    modal.one('updated', function () {
        modal.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
            modal.selectedCategory = node.__selected__ ? node.id : undefined;
            var items = modal.tags['catalog-tree'].tags.treeview.getSelectedNodes();
            if (items.length > 0) {
                var value = items.map(function (i) {
                    return i.id;
                }).join(',');
                modal.categoryFilters = [{ field: 'idFeatureGroup', sign: 'IN', value: value }];
            } else {
                modal.categoryFilters = false;
            }
            modal.update();
            modal.tags.catalog.reload();
        });
    });
});
});


// WEBPACK FOOTER //
// ./pages/products/parameters/parameters-list-select-modal.tag